import axios from "axios"

export default {
	namespaced: true,
	state: {
		tickets: [],
		total: 0,
		pagination: {
			size: 50,
			offset: 0
		}
	},
	mutations: {
		mutate(state, payload) {
			state[payload.element] = payload.value
		},

		SET_TICKETS(state, tickets) {
			state.tickets = tickets
		},
		SET_MAX(state, tickets) {
			state.total = tickets
		},
		PUSH_TICKET(state, newTicket) {
			state.tickets.push(newTicket)
		},
		UPDATE_TICKET(state, updatedTicket) {
			const index = state.tickets.findIndex(({ id }) => id === updatedTicket.id)
			if (index > -1) state.tickets[index] = updatedTicket
		}
	},
	actions: {
		doMutate({ commit }, payload) {
			commit("mutate", payload)
		},
		getTickets({ commit, state }) {
			var f = { ...state.pagination }
			var payload = { title: `%%`, pagination: f }

			return axios
				.post(`${process.env.VUE_APP_API_URL}/api/ticket/filter`, payload, {
					headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
				})
				.then(res => {
					commit("SET_MAX", res.data.total)
					commit("SET_TICKETS", res.data.tickets || [])
				})
				.catch(console.error)
		},
		filterTickets({ commit }, payload) {
			return axios
				.post(`${process.env.VUE_APP_API_URL}/api/ticket/filter`, payload, {
					headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
				})
				.then(res => {
					commit("SET_MAX", res.data.total)
					commit("SET_TICKETS", res.data.tickets || [])
				})
				.catch(console.error)
		},
		insertTicket({ commit }, payload) {
			return axios
				.post(`${process.env.VUE_APP_API_URL}/api/ticket/insert`, payload, {
					headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
				})
				.then(res => {
					commit("PUSH_TICKET", res.data)
					return res.data.id
				})
				.catch(() => this.$notification("error", this.$t("error-creating-ticket"), "", 0))
		},
		updateTicket({ commit }, { ticketId, payload }) {
			return axios
				.put(`${process.env.VUE_APP_API_URL}/api/ticket/${ticketId}`, payload, {
					headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
				})
				.then(({ data: ticket }) => commit("UPDATE_TICKET", ticket))
				.catch(() => this.$notification("error", this.$t("error-creating-ticket"), "", 0))
		}
	}
}
